<template>
  <div class="module-page">
    <!-- 搜索工具条 -->
    <el-card shadow="never" class="toolbar-card">
      <div class="toolbar">
        <el-input
          v-model="keyword"
          placeholder="输入关键字搜索"
          clearable
          class="keyword-input"
          @keyup.enter="handleSearch"
          @clear="handleSearch"
        />
        <el-button type="primary" :icon="Search" @click="handleSearch">查询</el-button>
        <el-button :icon="Refresh" @click="handleReset">重置</el-button>
        <div class="toolbar-right">
          <el-button type="success" plain :icon="Plus" @click="notReady">新增</el-button>
          <el-button plain :icon="Download" @click="notReady">导出</el-button>
        </div>
      </div>
    </el-card>

    <!-- 数据表格 -->
    <el-card shadow="never" class="table-card">
      <template #header>
        <span class="table-title">{{ moduleConf.name }}</span>
        <span class="table-tip">当前为模拟数据,后期由后端接口提供</span>
      </template>
      <el-table :data="rows" v-loading="loading" border stripe>
        <el-table-column type="index" label="#" width="50" align="center" />
        <el-table-column
          v-for="col in moduleConf.columns"
          :key="col.prop"
          :prop="col.prop"
          :label="col.label"
          :width="col.width"
          :min-width="col.minWidth || 110"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <el-tag v-if="col.type === 'tag'" :type="tagType(row[col.prop])" effect="light">
              {{ row[col.prop] }}
            </el-tag>
            <span v-else-if="col.type === 'amount'" class="amount">
              {{ formatAmount(row[col.prop]) }}
            </span>
            <span v-else>{{ row[col.prop] === '' || row[col.prop] == null ? '-' : row[col.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        v-model:current-page="page"
        v-model:page-size="pageSize"
        :total="total"
        :page-sizes="[10, 20, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        background
        @change="fetchData"
      />
    </el-card>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Search, Refresh, Plus, Download } from '@element-plus/icons-vue'
import { findModule } from '@/config/modules'
import { getList } from '@/api'

const route = useRoute()
const moduleConf = computed(() => findModule(route.meta.moduleKey) || { name: '', columns: [] })

const rows = ref([])
const total = ref(0)
const loading = ref(false)
const keyword = ref('')
const page = ref(1)
const pageSize = ref(10)

async function fetchData() {
  loading.value = true
  try {
    const res = await getList(moduleConf.value.key, {
      keyword: keyword.value,
      page: page.value,
      pageSize: pageSize.value
    })
    rows.value = res.list
    total.value = res.total
  } finally {
    loading.value = false
  }
}

function handleSearch() {
  page.value = 1
  fetchData()
}

function handleReset() {
  keyword.value = ''
  page.value = 1
  fetchData()
}

function notReady() {
  ElMessage.info('功能演示:待后端接口接入后开放')
}

// 状态标签颜色映射
function tagType(val) {
  const s = String(val)
  if (['优秀', '良好', '正常', '合格', '已售', '部分销售', '已免疫', '入库', '增强'].includes(s)) return 'success'
  if (['差', '异常', '不合格', '不足', '偏弱', '待免疫'].includes(s)) return 'danger'
  if (['一般', '待售', '待检', '略差'].includes(s)) return 'warning'
  return 'info'
}

function formatAmount(val) {
  const n = Number(val)
  return Number.isNaN(n) ? val : n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

// 切换模块路由时重新加载
watch(() => route.meta.moduleKey, () => {
  keyword.value = ''
  page.value = 1
  fetchData()
})

onMounted(fetchData)
</script>

<style scoped>
.toolbar-card {
  margin-bottom: 16px;
}
.toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.keyword-input {
  width: 240px;
}
.toolbar-right {
  margin-left: auto;
  display: flex;
  gap: 8px;
}
.table-title {
  font-weight: 600;
}
.table-tip {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}
.amount {
  color: #e6a23c;
  font-weight: 500;
}
.pagination {
  margin-top: 16px;
  justify-content: flex-end;
}
</style>
